import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-6 py-24 flex flex-col items-center text-center">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-400">
        <i className="ri-movie-line text-3xl" aria-hidden="true" />
      </span>
      <h1 className="mt-6 font-heading font-black text-5xl md:text-6xl text-primary-700 font-label">404</h1>
      <p className="mt-3 font-heading font-bold text-lg text-foreground-950">页面走丢了</p>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的页面不存在或已被移动
      </p>
      <div className="mt-7 flex items-center gap-3 flex-wrap justify-center">
        <Link
          to="/"
          className="h-10 px-6 inline-flex items-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category?type=movie"
          className="h-10 px-6 inline-flex items-center rounded-md border border-background-300 bg-background-50 hover:border-primary-300 text-foreground-800 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}